// assets
import { IconTypography, IconPalette, IconShadow, IconWindmill } from '@tabler/icons';
import ArticleIcon from '@mui/icons-material/Article';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    ArticleIcon,
    FolderOpenIcon,
    ViewQuiltIcon
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const reports = {
    id: 'reports',
    title: 'reports',
    type: 'group',
    children: [
        // {
        //     id: 'util-color',
        //     title: 'Color',
        //     type: 'item',
        //     url: '/utils/util-color',
        //     icon: icons.IconPalette,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'util-shadow',
        //     title: 'Shadow',
        //     type: 'item',
        //     url: '/utils/util-shadow',
        //     icon: icons.IconShadow,
        //     breadcrumbs: false
        // },
        {
            id: 'reports-aone',
            title: 'A-ONE Report',
            type: 'collapse',
            icon: icons.FolderOpenIcon,
            children: [
                {
                    id: 'reports-preoder',
                    title: 'Preorder Report (A-ONE)',
                    type: 'item',
                    url: '/reports/preorder',
                    icon: icons.ArticleIcon,
                    breadcrumbs: false
                },
                {
                    id: 'reports-preoder',
                    title: 'Invoice Report (A-ONE)',
                    type: 'item',
                    url: '/reports/invoice',
                    icon: icons.ArticleIcon,
                    breadcrumbs: false
                },
                {
                    id: 'reports-sales',
                    title: 'Sales Report (A-ONE)',
                    type: 'item',
                    url: '/reports/sales',
                    icon: icons.ArticleIcon,
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'reports-vip',
            title: 'VIP Report',
            type: 'collapse',
            icon: icons.FolderOpenIcon,
            children: [
                {
                    id: 'reports-preoder',
                    title: 'Dashboard Report (VIP)',
                    type: 'item',
                    url: '/reports/vip/dashboard',
                    icon: icons.ArticleIcon,
                    breadcrumbs: false
                },
                {
                    id: 'reports-sales-vip',
                    title: 'Sales Report (VIP)',
                    type: 'item',
                    url: '/reports/vip/sales',
                    icon: icons.ArticleIcon,
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default reports;
